package co.maytes.standupbot.dashboard.components.motion

import co.maytes.standupbot.dashboard.styles.Motion
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames

private const val CHEVRON_CLASS = "sb-chevron"

fun Modifier.rotatesWhenOpen(open: Boolean): Modifier =
    if (open) classNames(CHEVRON_CLASS, Motion.OPEN_CLASS) else classNames(CHEVRON_CLASS)
